import {gsap} from "gsap";

const Accordion = {

    init() {
        this.el = $('[component="Accordion"]');
        if(!this.el.length) return;
        this.items = this.el.find('.item');
		this.bind();
    },

	bind(){
        this.items.find('.label')
			.click((evt)=> {
				const el = $(evt.currentTarget).parent();
				if (!el.is('.expanded')) {
					Accordion.open(el);
				} else {
					Accordion.close(el)
				}
			})
	},

    open: function (item) {
        this.close(item.siblings('.expanded'));
        const content = item.find('.contents');
        item.addClass('expanded');

        gsap.set(content, {height: 'auto', paddingBottom: 0})
        gsap.from(content, {height: 0, paddingBottom: 0})
    },

    close: function (item) {
        if (!item.length) return;
        const content = item.find('.contents');
        item.removeClass('expanded');

        gsap.to(content, {height: 0, paddingBottom: 0})
    }
};

export default Accordion;